import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/search',
    name: 'search',
    meta: { moduleId: 'search' },
    component: () => import(/* webpackChunkName: "search" */ '@/views/search/List.vue'),
    beforeEnter: isAuthenticated,
  },
  {
    path: '/search/detail',
    name: 'search.detail',
    meta: { moduleId: 'search' },
    component: () => import(/* webpackChunkName: "search" */ '@/views/search/Detail.vue'),
    beforeEnter: isAuthenticated,
  },
];
